<template>
  <div class="col-12 px-0">
    <!-- Chart Of The Week -->
    <h2 class="text-black mb-3 pt-4">
      Chart Of The Week
    </h2>

    <form-control
      v-model="draft.steps.ephemera.chart_title"
      :no-margin="true"
      :errors="
        highlightFields && !draft.steps.ephemera.chart_title ? [' '] : []
      "
      title="Chart title"
      placeholder="Enter Chart Title"
      class="mb-3"
    />

    <div>
      <label>Upload Chart Image</label>
      <img
        v-if="draft.steps.ephemera.chart_image"
        :src="draft.steps.ephemera.chart_image.url"
        :alt="draft.steps.ephemera.chart_image.name"
        style="max-width: 520px;"
        class="d-block mb-2"
      />
      <FileUpload
        :action="`${url}upload/image`"
        :headers="headers"
        :class="{
          'is-invalid':
            highlightFields &&
            (draft.steps.ephemera.chart_image
              ? [draft.steps.ephemera.chart_image]
              : []
            ).length === 0
        }"
        @input="chartPictureUploaded"
        :value="
          draft.steps.ephemera.chart_image
            ? [draft.steps.ephemera.chart_image]
            : []
        "
        :accept="['image/png', 'image/jpeg']"
      />
      <!--

        <div v-else>
          <icon
            icon="add-image"
            class="m-0"
          />
          <div class="el-upload__text">
            Drop your file here or <em>Browse</em>
          </div>
        </div>
      </el-upload> -->
    </div>

    <div class="form-group">
      <label>Chart Source/Notes</label>

      <HtmlEditor
        v-model="draft.steps.ephemera.chart_source"
        :class="{
          'is-invalid':
            highlightFields &&
            (!draft.steps.ephemera.chart_source ||
              draft.steps.ephemera.chart_source === ' ')
        }"
        :token="`Bearer ${$login.getToken()}`"
        :image-upload-url="imageUploadUrl"
        :file-upload-url="fileUploadUrl"
      />
    </div>

    <div class="form-group border-bottom pb-5 mb-3">
      <label>Related Article</label>
      <autocomplete-article
        :class="{
          'is-invalid':
            highlightFields &&
            (!draft.steps.ephemera.chart_article ||
              !draft.steps.ephemera.chart_article.id)
        }"
        :original-title="
          draft.steps.ephemera.chart_article
            ? draft.steps.ephemera.chart_article.title
            : ''
        "
        @input="selectedArticle"
      />
    </div>
    <!-- This Weeks Most Read -->
    <h2 class="text-black my-3 mr-2">
      This Weeks Most Read
    </h2>

    <EphemeraMostReadFields
      without-synopsis
      id="1"
      :highlight-fields="highlightFields"
      v-model="draft.steps.ephemera.most_read1"
      @input="update('most_read1')"
    />
    <EphemeraMostReadFields
      without-synopsis
      id="2"
      :highlight-fields="highlightFields"
      v-model="draft.steps.ephemera.most_read2"
      @input="update('most_read2')"
    />
    <EphemeraMostReadFields
      without-synopsis
      id="3"
      :highlight-fields="highlightFields"
      v-model="draft.steps.ephemera.most_read3"
      @input="update('most_read3')"
    />
    <EphemeraMostReadFields
      without-synopsis
      id="4"
      v-model="draft.steps.ephemera.most_read4"
      @input="update('most_read4')"
    />
    <EphemeraMostReadFields
      without-synopsis
      id="5"
      v-model="draft.steps.ephemera.most_read5"
      class="border-bottom pb-4 mb-3"
    />

    <!-- Watching Brief -->
    <WatchingBriefSection v-model="draft.steps.ephemera.watching_brief" />

    <!-- In Case You Missed It -->
    <InCaseYouMissedItSection v-model="draft.steps.ephemera.audios" />

    <!-- Tellimer Events -->
    <TellimerEventsSection v-model="draft.steps.ephemera.events" />

    <!-- The Week Ahead -->
    <h2 class="text-black mb-3 pt-4">
      The Week Ahead
    </h2>

    <div class="form-group border-bottom pb-4 mb-4">
      <div
        v-for="day in draft.steps.ephemera.week_ahead"
        :key="`week-ahead-${day.day}`"
      >
        <label
          >{{ labelDate(day.date, 'MMMM Do') }}:
          <span class="text-muted">{{
            labelDate(day.date, 'dddd')
          }}</span></label
        >

        <form-control
          v-model="day.description"
          :no-margin="true"
          :errors="error ? error.errors.week_ahead[k] : []"
          class="mb-3"
          :placeholder="`Enter ${weekDaysLabels[day.day]} description`"
          type="textarea"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { HtmlEditor, FileUpload } from '@frontend/components'

import AutocompleteArticle from '@/components/AutocompleteArticle'
import EphemeraMostReadFields from '../ArticlesFields'
import InCaseYouMissedItSection from '../Components/InCaseYouMissedItSection'
import TellimerEventsSection from '../Components/TellimerEventsSection'
import WatchingBriefSection from '../Components/WatchingBriefSection'


export default {
  name: 'WeeklyRoundUpEphemeraStep',

  components: {
    AutocompleteArticle,
    EphemeraMostReadFields,
    InCaseYouMissedItSection,
    TellimerEventsSection,
    WatchingBriefSection,
    FileUpload,
    HtmlEditor
  },

  props: {
    draft: {
      type: Object,
      required: true
    },
    highlightFields: {
      required: true,
      type: Boolean
    },
    createdAt: {
      required: true,
      type: String
    }
  },

  data() {
    const chartPictures = []
    const briefVideoPictures = []
    const weekDaysLabelsDate = {}
    const weekDaysLabels = {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday'
    }

    /* eslint-disable camelcase */
    const { chart_image, watching_brief } = this.draft.steps.ephemera

    if (chart_image) {
      chartPictures[0] = chart_image
    }

    if (watching_brief && watching_brief.image) {
      briefVideoPictures[0] = watching_brief.image
    }
    /* eslint-enable */

    // get Week Ahead Date of Days Labels
    // let i = 0
    // for (const day in weekDaysLabels) {
    //   if (weekDaysLabels.hasOwnProperty(day)) {
    //     const date = this.getDayWeekAhead(i)
    //     weekDaysLabelsDate[day] = date.format('MMMM Do')

    //     i++
    //   }
    // }

    return {
      chartPictures,
      briefVideoPictures,
      error: null,
      url: process.env.VUE_APP_API_ENDPOINT,
      weekDaysLabels,
      weekDaysLabelsDate,
      imageUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/image',
      fileUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/file'
    }
  },

  beforeMount() {
    this.draft.steps.ephemera.audios = this.draft.steps.ephemera.audios || [
      { title: '', source: '', link: '' }
    ]
    this.draft.steps.ephemera.events = this.draft.steps.ephemera.events || [
      { date: '', description: '', link: '' }
    ]

    // define week ahead objects
    this.draft.steps.ephemera.week_ahead = this.draft.steps.ephemera
      .week_ahead || [
      { day: 'monday', description: '' },
      { day: 'tuesday', description: '' },
      { day: 'wednesday', description: '' },
      { day: 'thursday', description: '' },
      { day: 'friday', description: '' },
      { day: 'saturday', description: '' },
      { day: 'sunday', description: '' }
    ]

    for (const key in this.draft.steps.ephemera.week_ahead) {
      if (this.draft.steps.ephemera.week_ahead[key]) {
        this.draft.steps.ephemera.week_ahead[key].date = this.getDayWeekAhead(
          parseInt(key, 10)
        ).toISOString()
      }
    }

    /* eslint-disable camelcase */
    this.draft.steps.ephemera.most_read1 =
      this.draft.steps.ephemera.most_read1 || {}
    this.draft.steps.ephemera.most_read2 =
      this.draft.steps.ephemera.most_read2 || {}
    this.draft.steps.ephemera.most_read3 =
      this.draft.steps.ephemera.most_read3 || {}
    this.draft.steps.ephemera.most_read4 =
      this.draft.steps.ephemera.most_read4 || {}
    this.draft.steps.ephemera.most_read5 =
      this.draft.steps.ephemera.most_read5 || {}
    this.draft.steps.ephemera.watching_brief = this.draft.steps.ephemera
      .watching_brief || { link: '', source: '', image: null }
    /* eslint-enable */
  },

  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$login.getToken()
      }
    }
  },

  methods: {
    update(key = '') {
      this.$emit('update', {
        steps: {
          ephemera: {
            [key]: this.draft.steps.ephemera[key]
          }
        }
      })
    },

    selectedArticle(article) {
      const data = {id: null, title: null, analyst: null}
      if (article) {
        const { id, slug, title } = article
        data.id = id,
        data.title = title
        data.slug = slug
        data.analyst = article.leadAnalyst ? {
          name: article.leadAnalyst.name,
          job_title: article.leadAnalyst.jobTitle,
          picture_url: article.leadAnalyst.picture.square,
          company: article.leadAnalyst.channel ? article.leadAnalyst.channel.name : null,
          company_slug: article.leadAnalyst.channel
            ? article.leadAnalyst.channel.slug
            : null,
          slug: article.leadAnalyst.slug
        } : null

      }

      this.draft.steps.ephemera.chart_article = data
      this.update('chart_article')
    },

    chartPictureUploaded(fileList) {
      const img = !fileList[0]
        ? null
        : {
            name: fileList[0].name,
            url: fileList[0].url
          }

      this.draft.steps.ephemera.chart_image = img
      this.update('chart_image')
    },

    labelDate(date, format) {
      return moment(date).format(format)
    },
    getDayWeekAhead(weekDay = 0) {
      return moment(this.createdAt)
        .startOf('week')
        .day(7 + 1 + weekDay)
        .hour(12)
    }
  }
}
</script>
